import { wsService } from "./wsService";
import axios from "axios";

const api_url = process.env.VUE_APP_API_URL;
const section = "products";

const PRESENTATION_TYPE_UNIDAD = 1;
const PRESENTATION_TYPE_CAJA = 2;
const PRESENTATION_TYPE_PALLET = 3;

const STORAGE_UNITS_ID = 1;

const PRODUCT_COMPLETITUD_COMPLETO = "COM";
const PRODUCT_COMPLETITUD_INCOMPLETO = "INC";

const COMPLETITUD_STATES = [
  { id: PRODUCT_COMPLETITUD_COMPLETO, name: "Completo" },
  { id: PRODUCT_COMPLETITUD_INCOMPLETO, name: "Incompleto" },
];

const PRODUCT_STATUS_DISPONIBLE = 1;
const PRODUCT_STATUS_BLOQUEADO = 2;
const PRODUCT_STATUS_CUARENTENA = 3;
const PRODUCT_STATUS_VENCIDO = 4;

function filter(param = { enable: true }) {
  return wsService.make_post_request(section + "/list", param);
}

function list_minify(param = {}) {
  return wsService.make_post_request(section + "/list/minify", param);
}

function get(param = {}) {
  return wsService.make_post_request(section + "/get", param);
}

function create(param = {}) {
  return wsService.make_post_request(section + "/create", param);
}

function update(param = {}) {
  return wsService.make_put_request(section + "/update", param);
}

function remove(param = {}) {
  return wsService.make_delete_request(section + "/delete", param);
}

function list_presentations() {
  return wsService.make_post_request(section + "/presentations");
}

function filter_presentations() {
  return wsService.make_post_request(section + "/filter_presentations");
}

function getStates() {
  return wsService.make_get_request(section + "/product_status");
}

function tiposRotacoin() {
  return wsService.make_get_request(section + "/tipos_rotacion");
}

function frecuenciasRotacoin() {
  return wsService.make_get_request(section + "/frecuencias_rotacion");
}

function compositePresentationAmountFor(product_presentation_id, product_id, presentation_type_id) {
  const params = {
    product_presentation: product_presentation_id,
    product: product_id,
    presentation_type: presentation_type_id,
  };
  return wsService.make_post_request(section + "/composite_presentation_amount_for", params);
}

function print(param = {}, type) {
  var url = "";
  if (type == "zpl") {
    url = section + "/print/label/bulk/termica_zpl";
  }
  if (type == "pdf") {
    url = section + "/print/label/bulk/termica_pdf";
  }
  const token = localStorage.getItem("token");
  return axios
    .post(api_url + url, param, {
      responseType: "arraybuffer",
      headers: {
        Accept: "application/pdf",
        "Content-Type": "application/json; charset=utf-8",
        Authorization: "Bearer " + token,
      },
    })
    .catch((error) => {
      console.error("Network Error:", error);
    });
}

function getCompositions(param) {
  return wsService.make_post_request(section + "/get_presentation_base_by_client", param);
}

function scan(param = {}) {
  return wsService.make_post_request(section + "/scan", param);
}

function download_excel(param = {}) {
  return wsService.make_post_request(section + "/get-sample-excel", param);
}

function import_line_excel(param = {}) {
  return wsService.make_post_request(section + "/import-line", param);
}

function import_combo_line(param = {}) {
  return wsService.make_post_request(section + "/import-combo-line", param);
}

function import_incomplete_line(param = {}) {
  return wsService.make_post_request(section + "/import-incomplete-line", param);
}

function getProductAttributes(param = {}) {
  return wsService.make_post_request(section + "/get-product-attributes", param);
}

function get_excel_headers_version(param = {}) {
  return wsService.make_post_request(section + "/get-excel-headers-version", param);
}

function get_combo_excel_headers_version(param = {}) {
  return wsService.make_post_request(section + "/get-combo-excel-headers-version", param);
}

function get_incomplete_excel_headers_version(param = {}) {
  return wsService.make_post_request(section + "/get-incomplete-excel-headers-version", param);
}

function getCompletitudName(status) {
  const state = COMPLETITUD_STATES.find((s) => s.id === status);
  return state != null ? state.name : "";
}

function getCompletitudColor(status) {
  return status === PRODUCT_COMPLETITUD_INCOMPLETO ? "orange" : "green";
}

function getStatusColor(status) {
  switch (parseInt(status)) {
    case productoService.PRODUCT_STATUS_DISPONIBLE:
      return "success";
    case productoService.PRODUCT_STATUS_BLOQUEADO:
      return "warning";
    case productoService.PRODUCT_STATUS_CUARENTENA:
      return "info";
    case productoService.PRODUCT_STATUS_VENCIDO:
      return "error";
    default:
      return "primary";
  }
}

export const productoService = {
  section,
  filter,
  list_minify,
  get,
  remove,
  create,
  update,
  list_presentations,
  getStates,
  tiposRotacoin,
  frecuenciasRotacoin,
  compositePresentationAmountFor,
  print,
  getCompositions,
  scan,
  download_excel,
  import_line_excel,
  import_combo_line,
  import_incomplete_line,
  getProductAttributes,
  get_excel_headers_version,
  get_combo_excel_headers_version,
  get_incomplete_excel_headers_version,
  getStatusColor,
  getCompletitudName,
  getCompletitudColor,
  COMPLETITUD_STATES,
  PRODUCT_COMPLETITUD_COMPLETO,
  PRODUCT_COMPLETITUD_INCOMPLETO,
  PRESENTATION_TYPE_UNIDAD,
  PRESENTATION_TYPE_CAJA,
  PRESENTATION_TYPE_PALLET,
  PRODUCT_STATUS_DISPONIBLE,
  PRODUCT_STATUS_BLOQUEADO,
  PRODUCT_STATUS_CUARENTENA,
  PRODUCT_STATUS_VENCIDO,
  STORAGE_UNITS_ID,
};
